<mat-sidenav-container class="sidnav-container">

    <mat-sidenav class="sidnav" #sidenav [mode]="mode" opened *ngIf="userData && !isViewerMode()">
        <mat-list class="nav-menu-list">
            <mat-list-item class="mat-list-item" *ngIf="hasAccess('Dashboard')"
                [routerLink]="userData.user_type === 'HQ' ? '/dashboard-hq' : (userData.user_type === 'SHOP' ? '/dashboard-shop' : (userData.user_type === 'AREA_MANAGER' ? '/dashboard-area' : '/under-construction'))"
                [class.is-active]="isActive('/dashboard')" (click)="closeSidenav()">
                <div class="mat-list-item-contents">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" baseProfile="tiny" version="1.2"
                        viewBox="0 0 24 24" id="menu">
                        <path
                            d="M8 3H6a2.99 2.99 0 0 0-2.119.881A2.99 2.99 0 0 0 3 6v2c0 .825.337 1.575.881 2.119A2.99 2.99 0 0 0 6 11h2a2.99 2.99 0 0 0 2.119-.881A2.99 2.99 0 0 0 11 8V6a2.99 2.99 0 0 0-.881-2.119A2.99 2.99 0 0 0 8 3zm10 0h-2a2.99 2.99 0 0 0-2.119.881A2.99 2.99 0 0 0 13 6v2c0 .825.337 1.575.881 2.119A2.99 2.99 0 0 0 16 11h2a2.99 2.99 0 0 0 2.119-.881A2.99 2.99 0 0 0 21 8V6a2.99 2.99 0 0 0-.881-2.119A2.99 2.99 0 0 0 18 3zM8 13H6a2.99 2.99 0 0 0-2.119.881A2.99 2.99 0 0 0 3 16v2c0 .825.337 1.575.881 2.119A2.99 2.99 0 0 0 6 21h2a2.99 2.99 0 0 0 2.119-.881A2.99 2.99 0 0 0 11 18v-2a2.99 2.99 0 0 0-.881-2.119A2.99 2.99 0 0 0 8 13zm10 0h-2a2.99 2.99 0 0 0-2.119.881A2.99 2.99 0 0 0 13 16v2c0 .825.337 1.575.881 2.119A2.99 2.99 0 0 0 16 21h2a2.99 2.99 0 0 0 2.119-.881A2.99 2.99 0 0 0 21 18v-2a2.99 2.99 0 0 0-.881-2.119A2.99 2.99 0 0 0 18 13z">
                        </path>
                    </svg>
                    <span> Dashboard</span>
                </div>
            </mat-list-item>
            <mat-list-item class="mat-list-item hide-on-mobile" *ngIf="hasPageAccess('employee')" routerLink="/employee"
                [class.is-active]="isActive('/employee')">
                <div class="mat-list-item-contents">
                    <img src="assets/images/menu/svg/employees.svg" style="padding-top: 8px; height: 27px;"
                        onerror="this.src='assets/images/menu/svg/system.svg'">
                    <span>Employee</span>
                </div>
            </mat-list-item>
            <mat-list-item class="mat-list-item hide-on-mobile" *ngIf="hasPageAccess('roster')" routerLink="/roster"
                [class.is-active]="isActive('/roster')">
                <div class="mat-list-item-contents">
                    <img src="assets/images/menu/svg/roster.svg" style="padding-top: 8px; height: 27px;"
                        onerror="this.src='assets/images/menu/svg/system.svg'">
                    <span>Roster</span>
                </div>
            </mat-list-item>
            <mat-list-item class="mat-list-item hide-on-mobile" *ngIf="hasAccess('System')"
                routerLink="/system/job-position" [class.is-active]="isActive('/system')">
                <div class="mat-list-item-contents">
                    <img src="assets/images/menu/svg/system.svg" style="padding-top: 8px; height: 27px;">
                    <span>System</span>
                </div>
            </mat-list-item>
        </mat-list>
    </mat-sidenav>

    <mat-sidenav-content class="sidnav-content-container">
        <div class="contents">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>

</mat-sidenav-container>
<!-- <app-reward-submenu [show]="showRewardMenu"></app-reward-submenu> -->